module.exports = __webpack_public_path__ + "img/bird-1-right.56e1b584.png";